var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"netdisk-container"},[_c('van-uploader',{attrs:{"after-read":_vm.afterRead,"accept":"*"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }